export const FORM_RENDERER = "form-renderer.form-renderer";
export const symbolForFormStateStoreId = Symbol.for("form.stateStoreId");
//# sourceMappingURL=constants.js.map